import { useMemo } from 'react';
import { useSavedView } from '../../list/savedViews/useSavedView';
import { tableFieldsOf } from '../fieldsForColumns';
import { GridHiddenNote } from './GridHiddenNote';
import type { IGridFitNoteProps } from './IGridFitNoteProps';
import { useGridLayout } from './useGridLayout';
import './grid.css';

/**
 * Примітка «Приховано стовпців: N…» над картками, дошкою й календарем (прототип v4: hasColsHidden — для кожного подання списку, крім
 * розділеного): та сама розкладка стовпців, що й у таблиці, за шириною основної області; таблиця й редагування в рядку показують її самі.
 */
export function GridFitNote({ model }: IGridFitNoteProps) {
  const saved = useSavedView(model.ws, model.rt.key, model.state.savedViewId)?.definition;
  const fields = useMemo(() => tableFieldsOf(model.rt, model.columns), [model.rt, model.columns]);
  const layout = useGridLayout(model.rt, fields, Boolean(saved?.columns?.length));
  return <div ref={layout.ref} className="rg__fit"><GridHiddenNote count={layout.hidden} /></div>;
}
